import React from 'react';
import { EntityForm } from '../../widgets/Forms';
import { CustomTextField } from '../../widgets/CustomTextField';
import { LookupField } from '../../widgets/LookupField';
import { SelectItem } from '../../widgets/SelectItem';
import ProviderSearch from "../provider/ProviderSearch";
import EmployerSearch from "../employer/EmployerSearch";
import LearnerSearch from "../learner/LearnerSearch";
import { Row, Col } from 'react-bootstrap';
import ViewUtils from '../../ViewUtils';
import QualificationSetupSearch from '../program/QualificationSetupSearch';
import LearnershipSetupSearch from '../program/LearnershipSetupSearch';
import SkillsProgramSetupSearch from '../program/SkillsProgramSetupSearch';
import UnitStandardSetupSearch from '../program/UnitStandardSetupSearch';

const utils = new ViewUtils();

const BulkApprovalSearchForm = React.forwardRef((props, ref) => {
    const [dependency, setDependency] = React.useState(props.dependency);

    React.useEffect(() => {
        setDependency(props.dependency);
    }, [props.dependency]);

    return (
        <EntityForm ref={ref} viewId="learner" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="LearnerSearchForm">
                    <div className="row search-form-container">
                        <div className="col form-col">
                            <SelectItem
                                parentId={0}
                                dataUrl="api/sims/bulklearnerapproval/GetLookupList?listId=ApprovalType"
                                id="ApprovalTypeID"
                                required={true}
                                label="Approval Type"
                                className="w-100"
                                form={form}
                            />
                        </div>
                        <div className="col form-col">
                            <SelectItem
                                parentId={0}
                                dataUrl="api/sims/bulklearnerapproval/GetLookupListProgrammeType?parameter="
                                id="ProgrammeTypeID"
                                required={true}
                                label="Programme Type"
                                className="w-100"
                                form={form}
                                hasDependency={true}
                                dependency={dependency}
                            />
                        </div>
                        {
                            !utils.isNull(form.values["ProgrammeTypeID"]) && form.values["ProgrammeTypeID"].Description === "Qualification" ?
                                <div className="col form-col">
                                    <LookupField
                                        id="ProgrammeID"
                                        label="Qualification"
                                        className="w-100"
                                        required={false}
                                        form={form}
                                    >
                                        <QualificationSetupSearch
                                            showTitle={true}
                                            mode='lookup'
                                            dataUrl='api/sims/bulklearnerapproval/getqualificationsearch'
                                            onLookupValueChange={(value) => {
                                                form.setLookupSelection("ProgrammeID", value)
                                            }}
                                            autoFetchData={false}
                                            selection={props.selection}
                                        />
                                    </LookupField>
                                </div>
                                :
                                ""
                        }
                        {
                            !utils.isNull(form.values["ProgrammeTypeID"]) && form.values["ProgrammeTypeID"].Description === "Unit Standards" ?
                                <div className="col form-col">
                                    <LookupField
                                        id="ProgrammeID"
                                        label="Unit Standard"
                                        className="w-100"
                                        required={false}
                                        form={form}
                                    >
                                        <UnitStandardSetupSearch
                                            showTitle={true}
                                            mode='lookup'
                                            dataUrl='api/sims/bulklearnerapproval/getunitstandardsearch'
                                            onLookupValueChange={(value) => {
                                                form.setLookupSelection("ProgrammeID", value)
                                            }}
                                            autoFetchData={false}
                                            selection={props.selection}
                                        />
                                    </LookupField>
                                </div>
                                :
                                ""
                        }
                        {
                            !utils.isNull(form.values["ProgrammeTypeID"]) && form.values["ProgrammeTypeID"].Description === "Learnership" ?
                                <div className="col form-col">
                                    <LookupField
                                        id="ProgrammeID"
                                        label="Learnership"
                                        className="w-100"
                                        required={false}
                                        form={form}
                                    >
                                        <LearnershipSetupSearch
                                            showTitle={true}
                                            mode='lookup'
                                            dataUrl='api/sims/bulklearnerapproval/getlearnershipsearch'
                                            onLookupValueChange={(value) => {
                                                form.setLookupSelection("ProgrammeID", value)
                                            }}
                                            autoFetchData={false}
                                            selection={props.selection}
                                        />
                                    </LookupField>
                                </div>
                                :
                                ""
                        }
                        {
                            !utils.isNull(form.values["ProgrammeTypeID"]) && (form.values["ProgrammeTypeID"].Description === "Skills Programmes" || form.values["ProgrammeTypeID"].Description === "Mine Community" || form.values["ProgrammeTypeID"].Description === "Small Scale" || form.values["ProgrammeTypeID"].Description === "Unemployed Youth Development") ?
                                <div className="col form-col">
                                    <LookupField
                                        id="ProgrammeID"
                                        label="Skills Programme"
                                        className="w-100"
                                        required={false}
                                        form={form}
                                    >
                                        <SkillsProgramSetupSearch
                                            showTitle={true}
                                            mode='lookup'
                                            dataUrl='api/sims/bulklearnerapproval/getskillsprogrammesearch'
                                            onLookupValueChange={(value) => {
                                                form.setLookupSelection("ProgrammeID", value)
                                            }}
                                            autoFetchData={false}
                                            selection={props.selection}
                                        />
                                    </LookupField>
                                </div>
                                :
                                ""
                        }

                        <div className="col form-col">
                            <LookupField
                                id="LearnerID"
                                label="Learner"
                                className="w-100"
                                required={false}
                                form={form}
                            >
                                <LearnerSearch
                                    showTitle={true}
                                    mode='lookup'
                                    dataUrl='api/sims/bulklearnerapproval/LearnerSearch'
                                    onLookupValueChange={(value) => {
                                        form.setLookupSelection("LearnerID", value)
                                    }}
                                    autoFetchData={false}
                                    selection={props.selection}
                                />
                            </LookupField>
                        </div>

                        <div className="col form-col">
                            <LookupField
                                id="EmployerID"
                                label="Employer"
                                className="w-100"
                                required={false}
                                form={form}
                            >
                                <EmployerSearch
                                    showTitle={true}
                                    mode='lookup'
                                    dataUrl='api/sims/bulklearnerapproval/EmployerSearch'
                                    onLookupValueChange={(value) => {
                                        form.setLookupSelection("EmployerID", value)
                                    }}
                                    autoFetchData={false}
                                    selection={props.selection}
                                />
                            </LookupField>
                        </div>

                        <div className="col form-col">
                            <LookupField
                                id="ProviderID"
                                label="Provider"
                                className="w-100"
                                required={false}
                                form={form}
                            >
                                <ProviderSearch
                                    showTitle={true}
                                    mode='lookup'
                                    dataUrl='api/sims/bulklearnerapproval/ProviderSearch'
                                    onLookupValueChange={(value) => {
                                        form.setLookupSelection("ProviderID", value)
                                    }}
                                    autoFetchData={false}
                                    selection={props.selection}
                                />
                            </LookupField>
                        </div>
                        {
                            !utils.isNull(form.values["ApprovalTypeID"]) && form.values["ApprovalTypeID"].Description === "Endorsement" ?

                                <div className="col form-col">
                                    <SelectItem
                                        parentId={0}
                                        dataUrl="api/sims/bulklearnerapproval/GetLookupList?listId=QualityAssuranceBody"
                                        id="QualityAssuranceBodyID"
                                        label="QA Body"
                                        className="w-100"
                                        form={form}
                                    />
                                </div> : null
                        }
                    </div>
                </form>
            }
        </EntityForm >
    );
})

export default BulkApprovalSearchForm;